/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentPolicySelector,
  AgentPolicySelector$inboundSchema,
  AgentPolicySelector$Outbound,
  AgentPolicySelector$outboundSchema,
} from "./agentpolicyselector.js";

/**
 * Grant effect; direct agent policy is allow-only
 */
export const AgentPolicyGrantFormEffect = {
  Allow: "allow",
} as const;
/**
 * Grant effect; direct agent policy is allow-only
 */
export type AgentPolicyGrantFormEffect = OpenEnum<
  typeof AgentPolicyGrantFormEffect
>;

export type AgentPolicyGrantForm = {
  /**
   * Grant effect; direct agent policy is allow-only
   */
  effect: AgentPolicyGrantFormEffect;
  /**
   * Agent-runtime-safe scope to grant
   */
  scope: string;
  /**
   * A constraint that narrows which resources an agent grant applies to.
   */
  selector: AgentPolicySelector;
};

/** @internal */
export const AgentPolicyGrantFormEffect$inboundSchema: z.ZodMiniType<
  AgentPolicyGrantFormEffect,
  unknown
> = openEnums.inboundSchema(AgentPolicyGrantFormEffect);
/** @internal */
export const AgentPolicyGrantFormEffect$outboundSchema: z.ZodMiniType<
  string,
  AgentPolicyGrantFormEffect
> = openEnums.outboundSchema(AgentPolicyGrantFormEffect);

/** @internal */
export const AgentPolicyGrantForm$inboundSchema: z.ZodMiniType<
  AgentPolicyGrantForm,
  unknown
> = z.object({
  effect: AgentPolicyGrantFormEffect$inboundSchema,
  scope: z.string(),
  selector: AgentPolicySelector$inboundSchema,
});
/** @internal */
export type AgentPolicyGrantForm$Outbound = {
  effect: string;
  scope: string;
  selector: AgentPolicySelector$Outbound;
};

/** @internal */
export const AgentPolicyGrantForm$outboundSchema: z.ZodMiniType<
  AgentPolicyGrantForm$Outbound,
  AgentPolicyGrantForm
> = z.object({
  effect: AgentPolicyGrantFormEffect$outboundSchema,
  scope: z.string(),
  selector: AgentPolicySelector$outboundSchema,
});

export function agentPolicyGrantFormToJSON(
  agentPolicyGrantForm: AgentPolicyGrantForm,
): string {
  return JSON.stringify(
    AgentPolicyGrantForm$outboundSchema.parse(agentPolicyGrantForm),
  );
}
export function agentPolicyGrantFormFromJSON(
  jsonString: string,
): SafeParseResult<AgentPolicyGrantForm, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentPolicyGrantForm$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentPolicyGrantForm' from JSON`,
  );
}
